import { render, staticRenderFns } from "./imgDialog.vue?vue&type=template&id=020b83e3&scoped=true"
import script from "./imgDialog.vue?vue&type=script&lang=js"
export * from "./imgDialog.vue?vue&type=script&lang=js"
import style0 from "./imgDialog.vue?vue&type=style&index=0&id=020b83e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b83e3",
  null
  
)

export default component.exports